import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { calculateAgeInYears } from '../../../utils/growthCalculations';

const ChildrenList = ({ children, onSelectChild, onAddChild, onSettings }) => {
  const getAge = (dateOfBirth) => {
    const age = calculateAgeInYears(dateOfBirth, new Date());
    return age?.toFixed(1);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-text-primary">Children Profiles</h1>
        <div className="flex gap-3">
          <Button 
            onClick={onSettings}
            variant="outline"
            iconName="Settings"
          >
            Settings
          </Button>
          <Button 
            onClick={onAddChild}
            iconName="Plus"
          >
            Add Child
          </Button>
        </div>
      </div>

      {children?.length === 0 ? (
        <div className="bg-card border border-border rounded-lg p-12 text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-primary/10 p-6 rounded-full">
              <Icon name="Users" className="w-12 h-12 text-primary" />
            </div>
          </div>
          <h2 className="text-xl font-semibold text-text-primary mb-2">No Children Added Yet</h2>
          <p className="text-text-secondary mb-6">Create your first child profile to start tracking growth</p>
          <Button onClick={onAddChild} iconName="Plus">
            Add First Child
          </Button>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {children?.map((child) => (
            <div 
              key={child?.id}
              className="bg-card border border-border rounded-lg p-6 hover:border-primary transition-colors cursor-pointer"
              onClick={() => onSelectChild(child)}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center">
                  <div className="bg-primary/10 p-3 rounded-full mr-4">
                    <Icon name="User" className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-text-primary">{child?.nickname}</h3>
                    <p className="text-text-secondary text-sm">{getAge(child?.dateOfBirth)} years old</p>
                  </div>
                </div>
                <Icon name="ChevronRight" className="w-5 h-5 text-text-secondary" />
              </div>

              <div className="space-y-2">
                <div className="flex items-center text-sm">
                  <Icon name="Calendar" className="w-4 h-4 text-text-secondary mr-2" />
                  <span className="text-text-secondary">
                    Born: {new Date(child?.dateOfBirth)?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </span>
                </div>

                {child?.sportTags?.length > 0 && (
                  <div className="flex items-start text-sm">
                    <Icon name="Activity" className="w-4 h-4 text-text-secondary mr-2 mt-0.5" />
                    <div className="flex flex-wrap gap-1">
                      {child?.sportTags?.slice(0, 3)?.map((sport, idx) => (
                        <span key={idx} className="bg-primary/10 text-primary px-2 py-0.5 rounded text-xs">
                          {sport}
                        </span>
                      ))}
                      {child?.sportTags?.length > 3 && (
                        <span className="text-text-secondary text-xs">+{child?.sportTags?.length - 3} more</span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChildrenList;